import { toShorthandSize } from 'UIComponents/utils/propTypes/tshirtSize';
import { SIZE_OPTIONS } from 'UIComponents/loading/LoadingConstants';
import styled from 'styled-components';
import { AILoaderIllustration } from './internal/AILoaderIllustration';
import { AILoaderIllustrationSingleStar } from './internal/AILoaderIllustrationSingleStar';
import { useLayoutEffect, useState } from 'react';
import { StyledAnimatedLoaderEndingAnimation, StyledAnimatedLoaderEndingAnimationSingleStar, StyledAnimatedLoaderInitialAnimation, StyledAnimatedLoaderInitialAnimationSingleStar, StyledAnimatedLoaderLoadingAnimationSingleStar } from './internal/AILoaderAnimations';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getSizeInPx = (sizeName = 'md') => {
  if (sizeName === 'lg') {
    return '64px';
  }
  if (sizeName === 'xl') {
    return '128px';
  }
  return SIZE_OPTIONS[sizeName];
};
const StyledAnimatedLoaderContainer = styled.div.withConfig({
  displayName: "AILoader__StyledAnimatedLoaderContainer",
  componentId: "sc-1gay7xo-0"
})(["width:", "px;height:", "px;position:relative;"], props => props.width, props => props.height);
export const AILoader = ({
  size = 'lg',
  isFinished = false,
  onAnimationEnd
}) => {
  const [animationPhase, setAnimationPhase] = useState('start');
  const handleInitialAnimationEnd = () => {
    if (animationPhase === 'start') {
      setAnimationPhase('loading');
    }
  };
  useLayoutEffect(() => {
    if (isFinished && animationPhase === 'loading') {
      setAnimationPhase('end');
    }
  }, [isFinished, animationPhase]);
  useLayoutEffect(() => {
    if (!isFinished && animationPhase === 'end') {
      setAnimationPhase('start');
    }
  }, [isFinished, animationPhase]);
  const shorthandSize = toShorthandSize(size) || size;
  const spinnerSizePx = parseInt(getSizeInPx(shorthandSize), 10);
  return /*#__PURE__*/_jsxs(StyledAnimatedLoaderContainer, {
    width: spinnerSizePx,
    height: spinnerSizePx,
    role: "status",
    children: [animationPhase === 'start' && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(StyledAnimatedLoaderInitialAnimation, {
        onAnimationEnd: handleInitialAnimationEnd,
        children: /*#__PURE__*/_jsx(AILoaderIllustration, {
          width: spinnerSizePx,
          height: spinnerSizePx
        })
      }), /*#__PURE__*/_jsx(StyledAnimatedLoaderInitialAnimationSingleStar, {
        children: /*#__PURE__*/_jsx(AILoaderIllustrationSingleStar, {
          width: spinnerSizePx,
          height: spinnerSizePx
        })
      })]
    }), animationPhase === 'loading' && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(StyledAnimatedLoaderLoadingAnimationSingleStar, {
        children: /*#__PURE__*/_jsx(AILoaderIllustrationSingleStar, {
          width: spinnerSizePx,
          height: spinnerSizePx
        })
      })
    }), animationPhase === 'end' && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(StyledAnimatedLoaderEndingAnimation, {
        onAnimationEnd: onAnimationEnd,
        children: /*#__PURE__*/_jsx(AILoaderIllustration, {
          width: spinnerSizePx,
          height: spinnerSizePx
        })
      }), /*#__PURE__*/_jsx(StyledAnimatedLoaderEndingAnimationSingleStar, {
        children: /*#__PURE__*/_jsx(AILoaderIllustrationSingleStar, {
          width: spinnerSizePx,
          height: spinnerSizePx
        })
      })]
    })]
  });
};